/* global $ */
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';
import QRCode from 'qrcode';

const Certificateprint = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        batch_no: "",
        sr_no: "",
        Name: "",
        organization: "",
        designation: "",
        training_title: "",
        training_date: "",
        LMV_HMV_license_no: "",
        evaluate_grade_status: "",
        certificate_expired: "",
        training_atten_date: "",
        roll_no: "",
        aadhaar_no: "",
        id_card: "",
    });
    const [searchText, setSearchText] = useState('');
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers for the dropdown
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);

    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    // Function to format the date as "Mon, 10 Mar 2024"
    function formatDate(dateStr) {
        // If value is empty/null/undefined
        if (!dateStr) return '------------NA------------';

        const date = new Date(dateStr);

        // If invalid date or default epoch date (1970-01-01)
        if (isNaN(date.getTime()) || date.getFullYear() === 1970) {
            return '------------NA------------';
        }

        // Return in dd/mm/yyyy format
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    // Convert DD/MM/YYYY → YYYY-MM-DD
    const convertToMySQLDate = (dateStr) => {
        const [day, month, year] = dateStr.split('/');
        return `${year}-${month}-${day}`;
    };

    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to download certificate?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Download it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                mas_id: row.mas_id,
                batch_no: row.batch_no,
                sr_no: row.sr_no,
                Name: row.Name,
                organization: row.organization,
                designation: row.designation,
                training_title: row.training_title,
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                certificate_expired: isValidDate(new Date(row.certificate_expired)) ? convertToYYYYMMDD(row.certificate_expired) : "",
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                post_evaluation_test: row.post_evaluation_test,
                aadhaar_no: row.aadhaar_no,
                id_card: row.id_card,
            });
            $('#editRowModal').modal('show');
        }
    };

    function calculateValidUpTo(trainingDateStr) {
        if (!trainingDateStr) return "";

        let date = new Date(trainingDateStr); // trainingDateStr in YYYY-MM-DD format
        date.setMonth(date.getMonth() + 6);   // Add 6 months
        date.setDate(date.getDate() - 1);     // Subtract 1 day

        // Return YYYY-MM-DD format
        return date.toISOString().split("T")[0];
    }

    const monthMap = {
        Jan: 'F', Feb: 'G', Mar: 'H', Apr: 'J',
        May: 'K', Jun: 'M', Jul: 'N', Aug: 'Q',
        Sep: 'U', Oct: 'V', Nov: 'X', Dec: 'Z'
    };

    const dayMap = {
        Mon: 'B', Tue: 'D', Wed: 'A', Thu: 'E',
        Fri: 'I', Sat: 'R', Sun: 'C'
    };

    const generateRollNo = (trainingDateStr, validUpToStr, srNo) => {
        // Parse dates in DD/MM/YYYY format (same as PHP interpretation)
        const parseDate = (dateStr) => {
            // Handle both "DD/MM/YYYY" and "DD-MM-YYYY" formats
            const cleanStr = dateStr.replace(/[-]/g, '/');
            const parts = cleanStr.split('/');
            if (parts.length === 3) {
                // Convert DD/MM/YYYY to MM/DD/YYYY for JavaScript Date constructor
                return new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
            }
            return new Date(dateStr); // fallback
        };

        const trainingDate = parseDate(trainingDateStr);
        const validUpTo = parseDate(validUpToStr);

        if (isNaN(trainingDate) || isNaN(validUpTo)) return srNo; // fallback

        const trainingMonthCode = monthMap[trainingDate.toLocaleString('en-US', { month: 'short' })];
        const validMonthCode = monthMap[validUpTo.toLocaleString('en-US', { month: 'short' })];
        const validMonthNum = String(validUpTo.getMonth() + 1).padStart(2, '0');
        const dayCode = dayMap[trainingDate.toLocaleString('en-US', { weekday: 'short' })];

        return `${trainingMonthCode}${srNo}${validMonthCode}${validMonthNum}${dayCode}`;
    };



    const handleUpdate = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to update date and roll no?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Update it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            const validUpToDate = calculateValidUpTo(row.training_date);
            setSelectedRow(row);
            setNewRecord({
                mas_id: row.mas_id,
                batch_no: row.batch_no,
                sr_no: row.sr_no,
                Name: row.Name,
                organization: row.organization,
                designation: row.designation,
                training_title: row.training_title,
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                certificate_expired: isValidDate(new Date(row.certificate_expired)) ? convertToYYYYMMDD(row.certificate_expired) : "",
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                post_evaluation_test: row.post_evaluation_test,
                valid_up_to: convertToYYYYMMDD(validUpToDate),
                aadhaar_no: row.aadhaar_no,
                id_card: row.id_card,
            });
            $('#updateRowModal').modal('show');
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!selectedRow) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {

            // Generate new SR No based on logic
            console.log(newRecord.training_date, newRecord.valid_up_to, newRecord.sr_no)
            const newSrNo = generateRollNo(
                newRecord.training_date,
                newRecord.valid_up_to,
                newRecord.sr_no
            );
            const updatedData = {
                mas_id: selectedRow.mas_id,
                certificate_expired: convertToMySQLDate(newRecord.valid_up_to),
                sr_no: newSrNo,
            };

            try {
                await axios.put(`https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`, updatedData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                setData(data.map(item =>
                    item.mas_id === selectedRow.mas_id
                        ? { ...item, ...updatedData } // merge changes into existing item
                        : item
                ));

                $('#updateRowModal').modal('hide');
                Swal.fire('Saved!', 'The record has been updated.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue updating the record.', 'error');
            }
        }
    };



    const handleSelectAll = ({ selectedRows }) => {
        console.log("Selected Rows:", selectedRows);
        // Filter out any undefined IDs
        const ids = selectedRows.map(item => item.mas_id).filter(id => id !== undefined);
        if (ids.length > 0) {
            setSelectedIds(ids); // Select all IDs
        } else {
            setSelectedIds([]); // Clear all selections
        }
        console.log("Selected IDs after filtering:", ids); // Check final selected IDs
    };

    const handleSelect = (id) => {
        console.log("handleselect ", selectedIds);
        if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter(selectedId => selectedId !== id)); // Deselect if already selected
        } else {
            setSelectedIds([...selectedIds, id]); // Select if not already selected
        }
    };


    const handleOpenInNewTab = () => {
        const newWindow = window.open('', '', 'width=1000,height=800'); // Open a new window
        const documentContent = `
            <html>
            <head>
                <title>ID Cards</title>
                <style>
                    /* Normal styles for the ID cards */
                    .id-cards-container {
                        display: flex;
                        flex-wrap: wrap; /* Multiple cards on the same row */
                        gap: 40px; /* Add spacing between cards */
                        padding: 20px;
                    }

                    .id-card-wrapper {
                        display: flex;
                        flex-direction: row; /* Horizontal alignment */
                        justify-content: space-between; /* Left and right positioning */
                        gap: 40px;
                        align-items: center;
                    }

                    .id-card {
                        position: relative;
                        width: 400px; /* Adjust to match your image */
                        height: auto;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow for better visibility */
                        background-color: #fff; /* Optional: Set background color to white */
                    }

                    .id-card img {
                        width: 100%;
                        height: auto;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 10px; /* Adjust as needed */
                        color: #000;
                    }

                    /* Positioning the text on the card */
                    .pmcsub-contractor {  top: 19%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important; }
                    .pmcwork-location { top: 28%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important; }
                    .pmcaadhar { top: 36%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important; }
                    .pmcid-card-number { top: 45%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important; }
                    .pmcdl { top: 54%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important; }
                    .pmcdateofissue { top: 62%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important; }
                    .pmcdateofexpiry { top: 70%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important; }

                    .client { top: 19%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; display: flex; justify-content: flex-start; align-items: center; text-align: left; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; }
                    .name { top: 35%; left: 17%; position: absolute; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .topic { position: absolute; top: 42%; left: 17%; width: 230px; display: flex; align-items: center; justify-content: flex-start; min-height: 28px; line-height: 1.2; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left;  white-space: normal; word-break: break-word; }
                    .topic-long { position: absolute; top: 41%; left: 17%; width: 230px; display: flex; align-items: center; justify-content: flex-start; min-height: 28px; line-height: 1.2; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left;  white-space: normal; word-break: break-word; }
                    .designation { top: 55%; left: 17%; position: absolute; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .batchno { top: 24%; left: 75%; white-space: pre-wrap; width:80px; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .dateofissue { top: 62%; left: 20%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .validupto { top: 62%; left: 51%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    
                    .photo .passport-photo {
                        position: absolute;
                        top: 39%;       /* adjust to move vertically */
                        left: 72%;    /* adjust to move horizontally */
                        width: 100px;   /* small fixed size */
                        height: 130px;
                        object-fit: cover;   /* crop/fill without distortion */
                        border-radius: 4px;
                        z-index: 10;    /* stay on top but under UI elements if needed */
                    }

                    .mclient { top: 16%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; display: flex; justify-content: flex-start; align-items: center; text-align: left; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; }
                    .mname { top: 32%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .mtopic { top: 41%; left: 17%; position: absolute; white-space: normal; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; height: auto; line-height: 1.2; display: block; }
                    .mtopic-long { top: 38%; left: 17%; position: absolute; white-space: normal; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; height: auto; line-height: 1.2; display: block; }
                    .mdesignation { top: 51%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .mbatchno { top: 24%; left: 75%; white-space: pre-wrap; width:80px; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .mtraining-date { top: 59%; left: 20%; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}

                    .mwork-location { top: 23%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .maadhaar { top: 34%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .mid-card-number { top: 45%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .mmobile { top: 56%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}

                    
                    .mphoto .mpassport-photo {
                        position: absolute;
                        top: 39%;       /* adjust to move vertically */
                        left: 71.5%;    /* adjust to move horizontally */
                        width: 100px;   /* small fixed size */
                        height: 130px;
                        object-fit: cover;   /* crop/fill without distortion */
                        border-radius: 4px;
                        z-index: 10;    /* stay on top but under UI elements if needed */
                    }


                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }
                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .print-button {
                            display: none; /* Hide print button when printing */
                        }
                    }

                </style>
            </head>
            <body>
                <h1 style="text-align: center;">All ID Cards</h1>
                <div class="id-cards-container">
                ${data.map((batchNumbers, index) => {
            // Check if candidate_type is valid for rendering
            if (batchNumbers.candidate_type !== "Plant & Machinery" && batchNumbers.candidate_type !== "Management") {
                return ''; // Skip this item if candidate_type is invalid or empty
            }
            const isPlantMachinery = batchNumbers.candidate_type === "Plant & Machinery";
            const workCardImg = isPlantMachinery
                ? "dist/images/idcards/Plant Machinery 1.png"
                : "dist/images/idcards/Management 1.png";
            const certCardImg = isPlantMachinery
                ? "dist/images/idcards/Plant Machinery 2.png"
                : "dist/images/idcards/Management 2.png";
            const topicText = batchNumbers.training_title || '------------NA------------';
            const isLongTopic = topicText.length > 35;

            // Overlay content for PlantMachinery
            const plantMachineryworkCardOverlay = `
                        <div class="photo">
                            <img src="${batchNumbers.passport_size}" alt="Passport Photo" class="passport-photo" />
                        </div>
                        <p class="client">${batchNumbers.organization || '------------NA------------'}</p>
                        <p class="name">${batchNumbers.Name || '------------NA------------'}</p>
                        <p class="batchno">${batchNumbers.batch_no} - ${batchNumbers.sr_no || '------------NA------------'}</p>
                        <p class="${isLongTopic ? 'topic-long' : 'topic'}">${topicText}</p>
                        <p class="designation">${batchNumbers.designation || '------------NA------------'}</p>
                        <p class="dateofissue">${formatDate(batchNumbers.training_date) || '------------NA------------'}</p>
                        <p class="validupto">${formatDate(batchNumbers.certificate_expired) || '------------NA------------'}</p>
                    `;

            const mtopicText = batchNumbers.training_title || '------------NA------------';
            const isLongMTopic = mtopicText.length > 35;

            // Overlay content for Management
            const managementworkCardOverlay = `
                        <div class="mphoto">
                            <img src="${batchNumbers.passport_size}" alt="Passport Photo" class="mpassport-photo" />
                        </div>
                        <p class="mclient">${batchNumbers.organization || '------------NA------------'}</p>
                        <p class="mname">${batchNumbers.Name || '------------NA------------'}</p>
                        <p class="mbatchno">${batchNumbers.batch_no} - ${batchNumbers.sr_no || '------------NA------------'}</p>
                        <p class="${isLongMTopic ? 'mtopic-long' : 'mtopic'}">${mtopicText}</p>
                        <p class="mdesignation">${batchNumbers.designation || '------------NA------------'}</p>
                        <p class="mtraining-date">${formatDate(batchNumbers.training_date) || '------------NA------------'}</p>
                    `;

            // Overlay content for PlantMachinery
            const plantMachinerycertCardOverlay = `
                        <p class="pmcsub-contractor">${batchNumbers.sub_contractor || '------------NA------------'}</p>
                        <p class="pmcwork-location">${batchNumbers.work_location || '------------NA------------'}</p>
                        <p class="pmcaadhar">${batchNumbers.aadhaar_no || '------------NA------------'}</p>
                        <p class="pmcid-card-number">${batchNumbers.id_card || '------------NA------------'}</p>
                        <p class="pmcdl">${batchNumbers.LMV_HMV_license_no || '------------NA------------'}</p>                        
                        <p class="pmcdateofissue">${formatDate(batchNumbers.license_valid_from || '------------NA------------')}</p>
                        <p class="pmcdateofexpiry">${formatDate(batchNumbers.license_valid_to || '------------NA------------')}</p>
                    `;

            // Overlay content for Management
            const managementcertCardOverlay = `
                        <p class="mwork-location">${batchNumbers.work_location || '------------NA------------'}</p>
                        <p class="maadhaar">${batchNumbers.aadhaar_no || '------------NA------------'}</p>
                        <p class="mid-card-number">${batchNumbers.id_card || '------------NA------------'}</p>
                        <p class="mmobile">${batchNumbers.contact_no || '------------NA------------'}</p>
                    `;


            return `
                        <div class="id-card-wrapper" key="${index}">
                            <!-- Work Details Card -->
                            <div class="id-card work-details">
                                <img src="${workCardImg}" alt="Work Details Card" />
                                <div class="overlay">
                                    ${isPlantMachinery ? plantMachineryworkCardOverlay : managementworkCardOverlay}
                                </div>
                            </div>
        
                            <!-- Certificate Identity Card -->
                            <div class="id-card certificate-details">
                                <img src="${certCardImg}" alt="Certificate Card" />
                                <div class="overlay">
                                    ${isPlantMachinery ? plantMachinerycertCardOverlay : managementcertCardOverlay}
                                </div>
                            </div>
                        </div>
                    `;
        }).join('')}
                </div>
                <button class="print-button" onclick="window.print()">Print All Cards</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const handlePrintSelectedIdCards = () => {
        console.log("Selected IDs:", selectedIds);
        if (selectedIds.length === 0) {
            Swal.fire('Error!', 'Please select at least one ID card to print.', 'error');
            return;
        }

        const filteredData = data.filter(item => selectedIds.includes(item.mas_id));
        console.log("Filtered Data for Printing:", filteredData);

        const newWindow = window.open('', '', 'width=1000,height=800'); // Open a new window
        const documentContent = `
            <html>
            <head>
                <title>Selected ID Cards</title>
                <style>
                    /* Normal styles for the ID cards */
                    .id-cards-container {
                        display: flex;
                        flex-wrap: wrap; /* Multiple cards on the same row */
                        gap: 40px; /* Add spacing between cards */
                        padding: 20px;
                    }

                    .id-card-wrapper {
                        display: flex;
                        flex-direction: row; /* Horizontal alignment */
                        justify-content: space-between; /* Left and right positioning */
                        gap: 40px;
                        align-items: center;
                    }

                    .id-card {
                        position: relative;
                        width: 400px; /* Adjust to match your image */
                        height: auto;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow for better visibility */
                        background-color: #fff; /* Optional: Set background color to white */
                    }

                    .id-card img {
                        width: 100%;
                        height: auto;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 10px; /* Adjust as needed */
                        color: #000;
                    }

                    /* Positioning the text on the card */
                    .pmcsub-contractor { top: 19%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .pmcwork-location { top: 28%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .pmcaadhar { top: 36%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .pmcid-card-number { top: 45%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .pmcdl { top: 54%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .pmcdateofissue { top: 62%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .pmcdateofexpiry { top: 70%; left: 36%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}

                    .client { top: 19%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; display: flex; justify-content: flex-start; align-items: center; text-align: left; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; }
                    .name { top: 35%; left: 17%; position: absolute; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .topic { position: absolute; top: 42%; left: 17%; width: 230px; display: flex; align-items: center; justify-content: flex-start; min-height: 28px; line-height: 1.2; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left;  white-space: normal; word-break: break-word; }
                    .topic-long { position: absolute; top: 41%; left: 17%; width: 230px; display: flex; align-items: center; justify-content: flex-start; min-height: 28px; line-height: 1.2; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left;  white-space: normal; word-break: break-word; }
                    .designation { top: 55%; left: 17%; position: absolute; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .batchno { top: 24%; left: 75%; white-space: pre-wrap; width:80px; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .dateofissue { top: 62%; left: 20%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .validupto { top: 62%; left: 51%; font-size: 11px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    
                    .photo .passport-photo {
                        position: absolute;
                        top: 39%;       /* adjust to move vertically */
                        left: 72%;    /* adjust to move horizontally */
                        width: 100px;   /* small fixed size */
                        height: 130px;
                        object-fit: cover;   /* crop/fill without distortion */
                        border-radius: 4px;
                        z-index: 10;    /* stay on top but under UI elements if needed */
                    }

                    .mclient { top: 16%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; display: flex; justify-content: flex-start; align-items: center; text-align: left; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; }
                    .mname { top: 32%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .mtopic { top: 41%; left: 17%; position: absolute; white-space: normal; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; height: auto; line-height: 1.2; display: block; }
                    .mtopic-long { top: 38%; left: 17%; position: absolute; white-space: normal; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; height: auto; line-height: 1.2; display: block; }
                    .mdesignation { top: 51%; left: 17%; position: absolute; height: 35px; white-space: pre-wrap; width: 230px; font-size: 10px !important; font-family: "Cooper Black"; color: #005500 !important; text-align: left; }
                    .mbatchno { top: 24%; left: 75%; white-space: pre-wrap; width:80px; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}
                    .mtraining-date { top: 59%; left: 20%; font-size: 10px !important; font-family: "Arial Black"; color: #FF0000 !important;}

                    .mwork-location { top: 23%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .maadhaar { top: 34%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .mid-card-number { top: 45%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}
                    .mmobile { top: 56%; left: 35%; font-size: 11px !important; font-family: "Arial Black"; color: #005500 !important;}

                    
                    .mphoto .mpassport-photo {
                        position: absolute;
                        top: 39%;       /* adjust to move vertically */
                        left: 71.5%;    /* adjust to move horizontally */
                        width: 100px;   /* small fixed size */
                        height: 130px;
                        object-fit: cover;   /* crop/fill without distortion */
                        border-radius: 4px;
                        z-index: 10;    /* stay on top but under UI elements if needed */
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }
                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .print-button {
                            display: none; /* Hide print button when printing */
                        }
                    }

                </style>
            </head>
            <body>
                <h1 style="text-align: center;">Selected ID Cards</h1>
                <div class="id-cards-container">
                ${filteredData.map((batchNumbers, index) => {
            // Check if candidate_type is valid for rendering
            if (batchNumbers.candidate_type !== "Plant & Machinery" && batchNumbers.candidate_type !== "Management") {
                return ''; // Skip this item if candidate_type is invalid or empty
            }
            const isPlantMachinery = batchNumbers.candidate_type === "Plant & Machinery";
            const workCardImg = isPlantMachinery
                ? "dist/images/idcards/Plant Machinery 1.png"
                : "dist/images/idcards/Management 1.png";
            const certCardImg = isPlantMachinery
                ? "dist/images/idcards/Plant Machinery 2.png"
                : "dist/images/idcards/Management 2.png";

            const topicText = batchNumbers.training_title || '------------NA------------';
            const isLongTopic = topicText.length > 35;
            // Overlay content for PlantMachinery
            const plantMachineryworkCardOverlay = `
                        <div class="photo">
                            <img src="${batchNumbers.passport_size}" alt="Passport Photo" class="passport-photo" />
                        </div>
                        <p class="client">${batchNumbers.organization || '------------NA------------'}</p>
                        <p class="name">${batchNumbers.Name || '------------NA------------'}</p>
                        <p class="batchno">${batchNumbers.batch_no} - ${batchNumbers.sr_no || '------------NA------------'}</p>
                        <p class="${isLongTopic ? 'topic-long' : 'topic'}">${topicText}</p>
                        <p class="designation">${batchNumbers.designation || '------------NA------------'}</p>
                        <p class="dateofissue">${formatDate(batchNumbers.training_date) || '------------NA------------'}</p>
                        <p class="validupto">${formatDate(batchNumbers.certificate_expired) || '------------NA------------'}</p>
                    `;

            const mtopicText = batchNumbers.training_title || '------------NA------------';
            const isLongMTopic = mtopicText.length > 35;

            // Overlay content for Management
            const managementworkCardOverlay = `
                        <div class="mphoto">
                            <img src="${batchNumbers.passport_size}" alt="Passport Photo" class="mpassport-photo" />
                        </div>
                        <p class="mclient">${batchNumbers.organization || '------------NA------------'}</p>
                        <p class="mname">${batchNumbers.Name || '------------NA------------'}</p>
                        <p class="mbatchno">${batchNumbers.batch_no} - ${batchNumbers.sr_no || '------------NA------------'}</p>
                        <p class="${isLongMTopic ? 'mtopic-long' : 'mtopic'}">${mtopicText}</p>
                        <p class="mdesignation">${batchNumbers.designation || '------------NA------------'}</p>
                        <p class="mtraining-date">${formatDate(batchNumbers.training_date) || '------------NA------------'}</p>
                    `;

            // Overlay content for PlantMachinery
            const plantMachinerycertCardOverlay = `
                        <p class="pmcsub-contractor">${batchNumbers.sub_contractor || '------------NA------------'}</p>
                        <p class="pmcwork-location">${batchNumbers.work_location || '------------NA------------'}</p>
                        <p class="pmcaadhar">${batchNumbers.aadhar || '------------NA------------'}</p>
                        <p class="pmcid-card-number">${batchNumbers.id_card || '------------NA------------'}</p>
                        <p class="pmcdl">${batchNumbers.LMV_HMV_license_no || '------------NA------------'}</p>                        
                        <p class="pmcdateofissue">${formatDate(batchNumbers.license_valid_from || '------------NA------------')}</p>
                        <p class="pmcdateofexpiry">${formatDate(batchNumbers.license_valid_to || '------------NA------------')}</p>
                    `;

            // Overlay content for Management
            const managementcertCardOverlay = `
                        <p class="mwork-location">${batchNumbers.work_location || '------------NA------------'}</p>
                        <p class="maadhaar">${batchNumbers.aadhaar_no || '------------NA------------'}</p>
                        <p class="mid-card-number">${batchNumbers.id_card || '------------NA------------'}</p>
                        <p class="mmobile">${batchNumbers.contact_no || '------------NA------------'}</p>
                    `;


            return `
                        <div class="id-card-wrapper" key="${index}">
                            <!-- Work Details Card -->
                            <div class="id-card work-details">
                                <img src="${workCardImg}" alt="Work Details Card" />
                                <div class="overlay">
                                    ${isPlantMachinery ? plantMachineryworkCardOverlay : managementworkCardOverlay}
                                </div>
                            </div>
        
                            <!-- Certificate Identity Card -->
                            <div class="id-card certificate-details">
                                <img src="${certCardImg}" alt="Certificate Card" />
                                <div class="overlay">
                                    ${isPlantMachinery ? plantMachinerycertCardOverlay : managementcertCardOverlay}
                                </div>
                            </div>
                        </div>
                    `;
        }).join('')}
                </div>
                <button class="print-button" onclick="window.print()">Print Cards</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const bmrclpmCertificate = async (masid) => {
        console.log(masid);
        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }
        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>BMRCL PM Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .trainingdatefirst { top: 22%; left: 39%; font-size: 26px !important; font-family: "Arial Black"; color: #0A0A94;}
                    .trainingdatesecond { top: 22%; left: 53%; font-size: 26px !important; font-family: "Arial Black"; color: #C00000;}
                    .regno { top: 22%; left: 53.5%; font-size: 26px !important; font-family: "Arial Black"; color: #C00000;}
                    .client { top: 34%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62;}          /* Adjust as needed */
                    .organization { top: 38.5%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 54.8%; left: 29%; font-size: 25.33px !important; color: #C00000; }
                    .valid-date { top: 54.8%; right: 21%; font-size: 25.33px !important; color: #C00000; }
                    
                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 40px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 34.5%; left: 27%;  font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization {
                            top: 420px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 700px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 420px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 600px; left: 180px; font-size: 22px !important;}
                        .valid-date { top: 600px; right: 90px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/BMRCLPM.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">               
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>            
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            <p class="valid-date">${formatDate(certificateData.certificate_expired) || ''}</p>

                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const cmrlcprCertificate = async (masid) => {

        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }
        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>CMRL CPR Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 35%; left: 31%;  font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62;}          /* Adjust as needed */
                    .organization { top: 39.5%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 56%; left: 51%; font-size: 25.33px !important; color: #C00000; }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 560px;
                            bottom: 190px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 35%; left: 212px; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62; }      /* Example pixel values; adjust as needed */
                        .organization { 
                            top: 443px; 
                            left: 210px; 
                            font-size: clamp(18px, 1.8vw, 20px) !important;
                            font-family: "Cooper Black";
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long { 
                            top: 443px; 
                            left: 210px; 
                            font-size: 18px !important;
                            font-family: "Cooper Black";
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 618px; left: 405px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/CMRLCPR.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">  
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>             
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>

                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const cmrlmgCertificate = async (masid) => {

        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }

        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>CMRL MG Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 36.5%; left: 31%;  font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62; }          /* Adjust as needed */
                    .organization { top: 41%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62;  }
                    .issue-date { top: 54.5%; left: 51%;  font-size: 25.33px !important; color: #C00000; }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 40px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 34.5%; left: 212px; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization { 
                            top: 440px; 
                            left: 210px;
                            font-size: clamp(18px, 1.8vw, 20px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long { 
                            top: 440px; 
                            left: 210px;
                            font-size: 18px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 593px; left: 405px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/CMRLMG.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">  
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>             
                            <p class="client">${certificateData.Name || ''}</p>               
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const cmrlpmCertificate = async (masid) => {
        console.log(masid);
        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }

        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>CMRL PM Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 36%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62; }          /* Adjust as needed */
                    .organization { top: 40.5%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 55%; left: 29%; font-size: 25.33px !important; color: #C00000;  }
                    .valid-date { top: 55%; right: 21%; font-size: 25.33px !important; color: #C00000;  }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 40px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }
                    
                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 34.5%; left: 27%; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization {
                            top: 440px; 
                            left: 210px; 
                            font-size: clamp(18px, 2.5vw, 22px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 420px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }                       
                        .issue-date { top: 600px; left: 180px; font-size: 22px !important;}
                        .valid-date { top: 600px; right: 90px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/CMRLPM.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">  
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div> 
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>            
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            <p class="valid-date">${formatDate(certificateData.certificate_expired) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };
    
    const mmrclcprCertificate = async (masid) => {

        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }
        
        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>MMRCL CPR Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 37%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62; }          /* Adjust as needed */
                    .organization { top: 41.5%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 57%; left: 51%; font-size: 25.33px !important; color: #C00000; }

                     /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 560px;
                            bottom: 190px;
                            width: 110px;
                            height: 110px;
                        }
                    }
                        
                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 35%; left: 212px; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization { 
                            top: 445px; 
                            left: 210px;
                            font-size: clamp(18px, 1.8vw, 20px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 420px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 615px; left: 405px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/MMRCLCPR.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">               
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>
                             <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>               
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const mmrclpmCertificate = async (masid) => {
        console.log(masid);
        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }
        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>MMRCL PM Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 36%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62; }          /* Adjust as needed */
                    .organization { top: 40.5%; left: 31%;  font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 55%; left: 29%; font-size: 25.33px !important; color: #C00000; }
                    .valid-date { top: 55%; right: 21%; font-size: 25.33px !important; color: #C00000; }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 40px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 34.5%; left: 27%; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization {
                            top: 440px; 
                            left: 210px; 
                            font-size: clamp(18px, 1.8vw, 20px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 420px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 600px; left: 180px; font-size: 22px !important;}
                        .valid-date { top: 600px; right: 90px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/MMRCLPM.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">               
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>               
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>               
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            <p class="valid-date">${formatDate(certificateData.certificate_expired) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const pmCertificate = async (masid) => {
        console.log(masid);
        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }
        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>PM Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 34%; left: 33%;  font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62;}          /* Adjust as needed */
                    .designation { top: 38.5%; left: 37%;  font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62;}
                    .organization  { top: 43.5%; left: 31%;  font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62;}
                    .issue-date { top: 55%; left: 29%; font-size: 25.33px !important; color: #C00000; }
                    .valid-date { top: 55%; right: 21%; font-size: 25.33px !important; color: #C00000; }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 50px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }

                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 20%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 20%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 25%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 25%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 358px; left: 230px; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */                        
                        .designation { top: 415px; left: 270px; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}
                        .organization { 
                            top: 465px;     
                            left: 210px; 
                            font-size: clamp(18px, 1.8vw, 20px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 440px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .issue-date { top: 600px; left: 180px; font-size: 22px !important;}
                        .valid-date { top: 600px; right: 90px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 100px;   /* small fixed size */
                            height: 120px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/PLANTMACHINERY.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">               
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div>
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>              
                            <p class="client">${certificateData.Name || ''}</p>    
                            <p class="designation">${certificateData.designation || ''}</p>          
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''} </br> ${certificateData.sub_contractor || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            <p class="valid-date">${formatDate(certificateData.certificate_expired) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };

    const cmrlpmnscCertificate = async (masid) => {
        console.log(masid);
        // Fetch the data for the specific batch number
        const certificateData = data.find((item) => item.mas_id === masid);
        console.log(certificateData);
        if (!certificateData) {
            alert('Certificate data not found for the specified batch number.');
            return;
        }

        // viewer URL (Flask endpoint)
        const viewerUrl = `https://api.eazyworldehsengineering.com/api/candidate_registration/certificate/${certificateData.mas_id}`

        // Generate data URL for QR (client-side)
        let qrDataUrl = '';
        try {
            qrDataUrl = await QRCode.toDataURL(viewerUrl, { width: 300, margin: 1 });
        } catch (err) {
            console.error('QR generation failed, falling back to external', err);
            qrDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(viewerUrl)}`;
        }

        const orgText = `${certificateData.organization || ''} ${certificateData.sub_contractor || ''}`;
        const isLongOrg = orgText.length > 40;

        const titleText = certificateData.training_title || '';
        const isLongTitle = titleText.length > 45;

        const newWindow = window.open('', ''); // Open a new window
        const documentContent = `
            <!DOCTYPE html>
            <head>
                <title>CMRL PM Certificate</title>
                <style>
                    body, html {
                        margin: 0;
                        padding: 0;
                    }

                    .certificate-container {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        page-break-after: avoid;
                    }

                    /* Ensure full width and height for A4 printing */
                    @page {
                        size: A4;
                        margin: 0;
                    }
                        
                    .certificate-image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: 'Arial', sans-serif;
                        color: #000;
                    }

                    .overlay p {
                        position: absolute;
                        font-size: 15px;
                        font-weight: bold;
                    }

                    /* Adjust the exact position for each field */
                    .client { top: 36%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black"; color: #6B0C62; }          /* Adjust as needed */
                    .organization { top: 40.5%; left: 31%; font-size: 38.67px !important; font-family: "Cooper Black";  color: #6B0C62; }
                    .issue-date { top: 55%; left: 29%; font-size: 25.33px !important; color: #C00000;  }
                    .valid-date { top: 55%; right: 21%; font-size: 25.33px !important; color: #C00000;  }

                    /* QR bottom-left (no border/white space) */
                    .qr {
                    position: absolute;
                    left: 18px;
                    bottom: 18px;
                    width: 110px;
                    height: 110px;
                    z-index: 30;
                    }

                    @media print {
                        .qr {
                            left: 40px;
                            bottom: 40px;
                            width: 110px;
                            height: 110px;
                        }
                    }

                    /* Style for the print button */
                    .print-button {
                        display: block;
                        margin: 40px auto;
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: #4CAF50;
                        color: white;
                        border: none;
                        cursor: pointer;
                        text-align: center;
                    }

                    .print-button:hover {
                        background-color: #45a049;
                    }
                    
                    @media print {
                        .certificate-container {
                            width: 210mm; /* Exact width for A4 */
                            height: 297mm; /* Exact height for A4 */
                            overflow: hidden; /* Prevent any overflow */
                            page-break-after: avoid; /* Avoid page breaks after this element */
                        }
                        .print-button {
                            display: none; /* Hide input form when printing */
                        }
                        
                        .trainingdatefirst { top: 21.5%; left: 33%; font-size: 19px !important; font-family: "Arial Black"; color: #0A0A94;}
                        .trainingdatesecond { top: 21.5%; left: 53%; font-size: 19px !important; font-family: "Arial Black"; color: #C00000;}
                        .batch { top: 26.5%; left: 32%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .regno { top: 26.5%; left: 58%; font-size: 22px !important; font-family: "Arial Black"; color: #C00000;}
                        .client { top: 34.5%; left: 27%; font-size: clamp(20px, 2vw, 24px) !important; font-family: "Cooper Black"; color: #6B0C62;}      /* Example pixel values; adjust as needed */
                        .organization {
                            top: 450px; 
                            left: 210px; 
                            font-size: clamp(18px, 2.5vw, 22px) !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            width: 500px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .organization-long {
                            top: 440px; 
                            left: 210px; 
                            font-size: 20px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 600px;
                            white-space: normal;   /* allow wrapping */
                            word-break: break-word; /* break long words */
                            color: #6B0C62;
                        }
                        .title {
                            top: 540px; 
                            left: 20px; 
                            font-size: 25px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 750px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }
                        .title-long {
                            top: 540px; 
                            left: 10px; 
                            font-size: 21px !important;
                            font-family: "Cooper Black"; 
                            line-height: 1.2;
                            display: inline-block;
                            font-weight: "bold",
                            margin: 0;
                            padding: 0;
                            width: 800px;
                            text-align: center; /* Center the text */
                            white-space: normal;    /* allow text to wrap */
                            word-wrap: break-word;  /* ensure wrapping of long words */
                            color: #6B0C62;
                        }                        
                        .issue-date { top: 600px; left: 180px; font-size: 22px !important;}
                        .valid-date { top: 600px; right: 90px; font-size: 22px !important;}
                        .photo .passport-photo {
                            position: absolute;
                            top: 23%;       /* adjust to move vertically */
                            left: 79%;    /* adjust to move horizontally */
                            width: 130px;   /* small fixed size */
                            height: 150px;
                            object-fit: cover;   /* crop/fill without distortion */
                            border-radius: 4px;
                            z-index: 10;    /* stay on top but under UI elements if needed */
                        }
                    }

                </style>
            </head>
            <body>
                <div class="certificate-container">
                    <div class="certificate-page">
                        <img src="dist/images/idcards/CMRLPM.jpg" alt="Certificate" class="certificate-image">
                        <div class="overlay">  
                            <div class="photo">
                                <img src="${certificateData.passport_size}" alt="Passport Photo" class="passport-photo" />
                            </div> 
                            <p class="trainingdatefirst">Training Date –<p class="trainingdatesecond">${formatDate(certificateData.training_date) || ''}</p></p>              
                            <p class="batch">${certificateData.batch_no || ''} – <span class="regno">${certificateData.sr_no || ''}</span></p>            
                            <p class="client">${certificateData.Name || ''}</p>              
                            <p class="${isLongOrg ? 'organization-long' : 'organization'}">${certificateData.organization || ''}</p>
                            <p class="${isLongTitle ? 'title-long' : 'title'}">"${titleText}"</p>
                            <p class="issue-date">${formatDate(certificateData.training_date) || ''}</p>
                            <p class="valid-date">${formatDate(certificateData.certificate_expired) || ''}</p>
                            
                            <!-- QR image (data URL) -->
                            <img src="${qrDataUrl}" alt="QR code" class="qr" />
                        </div>
                    </div>
                </div>
                <button class="print-button" onclick="window.print()">Print</button>
            </body>
            </html>
        `;

        newWindow.document.write(documentContent); // Write the content to the new window
        newWindow.document.close(); // Close the document to ensure it renders
    };


    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }

        setIsLoading(true); // Set loading state

        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/?batch_no=${selectedBatchNo}`);

            // Check if the data is valid before setting it
            if (response.data && Array.isArray(response.data)) {
                const formattedData = response.data.map(item => ({
                    ...item,
                    date_field: item.date_field ? formatDate(item.date_field) : item.date_field // Format date only if present
                }));
                setData(formattedData);
                console.log(formattedData);
            } else {
                Swal.fire('Error!', 'Unexpected data format received.', 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        } finally {
            setIsLoading(false); // Reset loading state
        }
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo(''); // Clear dropdown selection
        setData([]); // Clear DataTable data
    };

    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setNewRecord(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const filteredData = data.filter(item => {
        return (
            (item.batch_no && item.batch_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.sr_no && item.sr_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.training_title && item.training_title.toLowerCase().includes(searchText.toLowerCase()))
        );
    });


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name,
            width: '200px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Training Title</span>,
            selector: row => row.training_title,
            width: '300px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Status</span>,
            selector: row => row.evaluate_grade_status,
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Valid Upto</span>,
            selector: row => formatDate(row.certificate_expired),
            width: '120px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Action</span>,
            cell: row => (
                <div>
                    <button className="btn btn-primary btn-sm mr-2" onClick={() => handleEdit(row)}>
                        <i className="fa fa-address-card"></i>
                    </button>
                    <button className="btn btn-primary btn-sm" onClick={() => handleUpdate(row)}>
                        <i className="fa fa-edit"></i>
                    </button>
                </div>
            ),
            width: '120px',
            ignoreRowClick: true,
            allowoverflow: true,
        }
    ];

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Certificate Print</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Certificate Print</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filter Panel */}
            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title">
                                <i className="fas fa-filter mr-2"></i> Select Batch & Search
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>

                                <div className="form-group col-md-3">
                                    <label>Select Batch Number</label>
                                    <select
                                        id="batchNumber"
                                        className="form-control"
                                        value={selectedBatchNo}
                                        onChange={(e) => setSelectedBatchNo(e.target.value)}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map((batchNo) => (
                                            <option key={batchNo} value={batchNo}>
                                                {batchNo}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3 d-flex justify-content-start gap-2">
                                    <button className="btn btn-primary mr-2" onClick={handleViewButtonClick} disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin mr-1"></i> Loading...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-eye mr-1"></i> View
                                            </>
                                        )}
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleResetButtonClick}>
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>

                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Search + Action Buttons */}
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-info card-outline">
                        <div className="card-header">
                            <h5 className="card-title">
                                <i className="fas fa-id-card-alt mr-2"></i> ID Card Actions
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group row">
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-md-8 text-right">
                                    <button className="btn btn-primary btn-sm mr-2" onClick={handleOpenInNewTab}>
                                        <i className="fas fa-print mr-1"></i> Print All ID Cards
                                    </button>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handlePrintSelectedIdCards}
                                        disabled={handleSelect.length === 0}
                                    >
                                        <i className="fas fa-check-square mr-1"></i> Print Selected ID Cards
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    selectableRows
                                    onSelectedRowsChange={handleSelectAll}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                    highlightOnHover
                                    striped
                                    className="table table-bordered table-hover"
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h5 className="modal-title text-white">Print Certificates</h5>
                                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    {/* Basic Info */}
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Name:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.Name}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Training Date:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.training_date}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Organization:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.organization}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Batch No:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.batch_no}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">License No:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.LMV_HMV_license_no}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Certificate Buttons */}
                                                    <div className="form-section mb-4">
                                                        <hr />
                                                        <h4 className="text-primary">Certificates</h4>
                                                    </div>

                                                    <div className="row mb-3 text-center">
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => bmrclpmCertificate(newRecord.mas_id)}>
                                                                BMRCL PM
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => cmrlcprCertificate(newRecord.mas_id)}>
                                                                CMRL CPR
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => cmrlmgCertificate(newRecord.mas_id)}>
                                                                CMRL MG
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => cmrlpmCertificate(newRecord.mas_id)}>
                                                                CMRL PM
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4 text-center">
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => mmrclcprCertificate(newRecord.mas_id)}>
                                                                MMRCL CPR
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => mmrclpmCertificate(newRecord.mas_id)}>
                                                                MMRCL PM
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => pmCertificate(newRecord.mas_id)}>
                                                                PMCR
                                                            </button>
                                                        </div>
                                                        <div className="col-md-3 mb-2">
                                                            <button type="button" className="btn btn-outline-primary w-100" onClick={() => cmrlpmnscCertificate(newRecord.mas_id)}>
                                                                CMRL PM WSC
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <div className="modal-footer border-0">
                                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                                            Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Update Modal */}
                                <div className="modal fade" id="updateRowModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h5 className="modal-title text-white">Update Details</h5>
                                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    {/* Basic Info */}
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Name:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.Name}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Training Attend Date:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.training_atten_date}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Roll No:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.sr_no}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Batch No:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.batch_no}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Organization:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.organization}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <h6 className="text-muted mb-0">Date of Issue:</h6>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <p className="mb-0">{newRecord.training_date}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div class="row align-items-center">
                                                            <label for="validupto" class="col-sm-6 col-form-label">Valid Up To</label>
                                                            <div class="col-sm-6">
                                                                <input
                                                                    id="valid_up_to"
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newRecord.valid_up_to}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <div className="modal-footer border-0">
                                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                                            Close
                                                        </button>
                                                        <button type="submit" className="btn btn-primary">Save Changes</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Certificateprint;
